import React from 'react'
import PropTypes from 'prop-types'

const SimpleDateField = props => {
    const { id, value, placeholder, type, onChange, disabled = false, testid, classes = '', propid } = props

    return (
        <>
            <div style={{ width: '47.8%' }} className={`border-1 border-base rounded divide-base align-middle bg-gray-5 focus:bg-white ${classes}`} >
                <input data-propid={propid} data-testid={testid} id={id} value={value} onChange={onChange} disabled={disabled} className={'form-control border-0 pr-1'}
                    type={type} placeholder={placeholder} />
            </div>
        </>
    )
}

export default SimpleDateField

SimpleDateField.propTypes = {
    id: PropTypes.string,
    propid: PropTypes.string,
    testid: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    onChange: PropTypes.any,
    disabled: PropTypes.bool,
    classes: PropTypes.string
}
